export default {
  "nl": {
    "issue_category": {
      "labels": {
        "category_name": "Categorienaam",
        "integration_warning": "Een integratie met de Nazorg module op uw platform is actief. Vraag het ons als u categorieën wilt maken of bewerken.",
        "new_category": "Nieuwe probleemcategorie"
      }
    }
  }
}